<template>
  <router-view />
</template>

<script>
export default {
  name: 'campaign-points-pages-container',
};
</script>
